import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bca550a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4"
}
const _hoisted_2 = { class: "relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col" }
const _hoisted_3 = { class: "flex items-start justify-between gap-4" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_6 = {
  key: 0,
  class: "px-2 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full"
}
const _hoisted_7 = {
  key: 1,
  class: "px-2 py-1 text-xs font-medium bg-primary-100 text-primary-600 rounded-full"
}
const _hoisted_8 = {
  key: 2,
  class: "px-2 py-1 text-xs font-medium bg-blue-100 text-blue-700 rounded-full capitalize"
}
const _hoisted_9 = { class: "text-xl font-heading font-bold text-primary-800" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "p-6 overflow-y-auto flex-1" }
const _hoisted_13 = { class: "flex items-start gap-4 mb-6" }
const _hoisted_14 = { class: "text-xs font-medium uppercase" }
const _hoisted_15 = { class: "text-xl font-bold leading-none" }
const _hoisted_16 = { class: "font-semibold text-primary-800" }
const _hoisted_17 = {
  key: 0,
  class: "text-primary-500"
}
const _hoisted_18 = {
  key: 1,
  class: "text-primary-500"
}
const _hoisted_19 = {
  key: 0,
  class: "flex items-start gap-3 mb-6"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-primary-400 mt-0.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
  })
], -1))
const _hoisted_21 = { class: "text-primary-700" }
const _hoisted_22 = { class: "prose prose-primary max-w-none" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 1,
  class: "text-primary-400 italic"
}
const _hoisted_25 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "p-4 border-t border-primary-100 bg-primary-50" }
const _hoisted_28 = { class: "flex items-center justify-between" }
const _hoisted_29 = {
  key: 0,
  class: "text-xs text-primary-400"
}
const _hoisted_30 = {
  key: 1,
  class: "text-xs text-primary-400"
}
const _hoisted_31 = { class: "flex gap-2" }
const _hoisted_32 = ["href"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
  })
], -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = ["href"]

import { sanitizeHtml } from "@/utils/sanitize";


export default /*#__PURE__*/_defineComponent({
  props: {
    event: null
  },
  emits: ["close"],
  setup(__props: any) {





// Parse date string as local time (not UTC)
const parseLocalDate = (dateStr: string | null | undefined) => {
  if (!dateStr) return new Date();
  return new Date(dateStr.replace(/-/g, "/"));
};

const formatMonth = (dateStr: string | null | undefined) => {
  if (!dateStr) return "---";
  const date = parseLocalDate(dateStr);
  return date.toLocaleDateString("en-US", { month: "short" });
};

const formatDay = (dateStr: string | null | undefined) => {
  if (!dateStr) return "--";
  const date = parseLocalDate(dateStr);
  return date.getDate();
};

const formatFullDate = (dateStr: string | null | undefined) => {
  if (!dateStr) return "Date TBD";
  const date = parseLocalDate(dateStr);
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (__props.event)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "absolute inset-0 bg-primary-900/70 backdrop-blur-sm",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass(["p-6 border-b border-primary-100", __props.event.isNeighborhood ? 'bg-accent-50' : 'bg-primary-50'])
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (__props.event.isNeighborhood)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " HOA Event "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_7, " Local Event ")),
                        (__props.event.type)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.event.type), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("h2", _hoisted_9, _toDisplayString(__props.event.title), 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                      class: "text-primary-400 hover:text-primary-600 transition-colors p-1"
                    }, _hoisted_11)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["w-14 h-14 rounded-xl flex flex-col items-center justify-center flex-shrink-0", 
                  __props.event.isNeighborhood
                    ? 'bg-accent-100 text-accent-700'
                    : 'bg-primary-100 text-primary-600'
                ])
                    }, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(formatMonth(__props.event.date)), 1),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(formatDay(__props.event.date)), 1)
                    ], 2),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(formatFullDate(__props.event.date)), 1),
                      (__props.event.time)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(__props.event.time), 1))
                        : _createCommentVNode("", true),
                      (__props.event.end_date)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, " through " + _toDisplayString(formatFullDate(__props.event.end_date)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (__props.event.venue || __props.event.location)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("p", _hoisted_21, _toDisplayString(__props.event.venue || __props.event.location), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_22, [
                    (__props.event.description)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          innerHTML: _unref(sanitizeHtml)(__props.event.description),
                          class: "text-primary-600"
                        }, null, 8, _hoisted_23))
                      : (_openBlock(), _createElementBlock("p", _hoisted_24, " No additional details available. "))
                  ]),
                  (__props.event.image || __props.event.image_url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("img", {
                          src: __props.event.image || __props.event.image_url,
                          alt: __props.event.title,
                          class: "w-full rounded-lg object-cover max-h-64"
                        }, null, 8, _hoisted_26)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    (__props.event.source_name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, " Source: " + _toDisplayString(__props.event.source_name), 1))
                      : (__props.event.isNeighborhood)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, " Foxwood Crossing HOA "))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_31, [
                      (__props.event.attachment)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: __props.event.attachment,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded-lg hover:bg-primary-700 transition-colors inline-flex items-center gap-2"
                          }, _hoisted_35, 8, _hoisted_32))
                        : _createCommentVNode("", true),
                      (__props.event.url && __props.event.url !== '#')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: __props.event.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "px-4 py-2 bg-accent-600 text-white text-sm font-medium rounded-lg hover:bg-accent-700 transition-colors"
                          }, " Learn More ", 8, _hoisted_36))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
                        class: "px-4 py-2 bg-primary-100 text-primary-700 text-sm font-medium rounded-lg hover:bg-primary-200 transition-colors"
                      }, " Close ")
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})